import { render, staticRenderFns } from "./PostAssessment.vue?vue&type=template&id=6e5fdcf9"
import script from "./PostAssessment.vue?vue&type=script&lang=js"
export * from "./PostAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports